import Axios from "axios";
import mutationTypes from "./mutation-types";
import getAuthService from "@/services/AuthService";

const handleError = (error: any) => {
    throw new Error(error?.response?.data?.code || error.code || error.message);
};

const check = async ({ commit, dispatch }) => {
    try {
        const currentSession = localStorage.getItem("stqr_token");
        if (!currentSession) {
            throw new Error();
        }

        Axios.defaults.headers.common.Authorization = `session ${currentSession}`;

        const response: {
            success: boolean;
            role: string;
            termsAndConditionsConsent?: Date;
            loginCookieConsent?: boolean;
            shareEmailConsent?: boolean;
            is_argo_user: boolean;
        } = await getAuthService().checkAuth();

        const data = {
            role: response.role,
            isArgoUser: response.is_argo_user
        };
        commit(mutationTypes.CHECK, data);
    } catch (e) {
        dispatch("logout");
    }
};

const login = async ({ commit }, { email, password, remindsMe, accountCreated }) => {
    try {
        const sessionData = await getAuthService().login(email, password);
        commit(mutationTypes.LOGIN, { ...sessionData, remindsMe, accountCreated });
    } catch (e) {
        handleError(e);
    }
};

/**
 * send auth code to server to validate the code and create the session
 */
const googleSignIn = async ({ commit }, token) => {
    try {
        const sessionData = await getAuthService().signInWithGoogle(token);
        commit(mutationTypes.LOGIN, { ...sessionData, remindsMe: true });
    } catch (e) {
        handleError(e);
    }
};

const logout = async ({ commit }, data: { keepStorage?: boolean } = { keepStorage: false }) => {
    if (data?.keepStorage) {
        commit(mutationTypes.SOFT_LOGOUT);
    } else {
        commit(mutationTypes.LOGOUT);
    }
};

const register = async ({ dispatch }, { name, email, password, remindsMe }) => {
    try {
        await getAuthService().register(name, email, password);
        dispatch("login", { email, password, remindsMe, accountCreated: true });
    } catch (e) {
        handleError(e);
    }
};

export default {
    check,
    login,
    logout,
    register,
    googleSignIn
};
